// Copyright © 2021 Move Closer
import { TokenType } from '@d24/demarked';
import { AbstractAdapter } from '../_abstract/adapter';
import { getModuleBase } from '../_helpers/adapter';
import { ModuleDriver } from '../_contracts';
import { DataSetVersion } from './DataSet.contracts';
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export class DataSetAdapter extends AbstractAdapter {
    /**
     * @inheritDoc
     */
    objectToToken(object, storage) {
        if (!storage) {
            throw new Error('Argument of storage should be present to [image] module');
        }
        const identifier = typeof object.id !== 'undefined' ? object.id : storage.uniqueKey();
        storage.store(identifier, object.content.dataSet);
        return {
            content: identifier,
            raw: `#DATA[ id: ${identifier} ]`,
            type: TokenType.DataSet
        };
    }
    /**
     * @inheritDoc
     */
    tokenToObject(token, storage) {
        if (!storage) {
            throw new Error('Argument of storage should be present to [image] module');
        }
        const dataSet = storage.retrieve(token.content, {});
        return {
            ...getModuleBase(),
            content: { dataSet },
            driver: ModuleDriver.DataSet,
            version: DataSetVersion.Table
        };
    }
}
